import { ChainId } from '../sdk/chainId'

import { getChain } from './active'

function requireConfigured(chainId: ChainId) {
  const chain = getChain(chainId)
  if (!chain.configured) {
    throw new Error(`[config] La cadena ${chain.key} (${chainId}) aún no está configurada`)
  }
  return chain
}

export function getFactoryAddress(chainId: ChainId): string {
  return requireConfigured(chainId).contracts.factory
}

export function getInitCodeHash(chainId: ChainId): string {
  return requireConfigured(chainId).contracts.initCodeHash
}

export function getRouterAddress(chainId: ChainId): string {
  return requireConfigured(chainId).contracts.router
}

export function getMulticallAddress(chainId: ChainId): string {
  return requireConfigured(chainId).contracts.multicall
}

export function getWethAddress(chainId: ChainId): string {
  return requireConfigured(chainId).contracts.weth
}

export function getExplorerBaseUrl(chainId: ChainId): string {
  return getChain(chainId).explorer.baseUrl
}
